<template>
    <div class="actions" :class="{ padded: needsPadding }">
        <div class="form-field">
            <v-btn
                v-if="hasSubmitBtn"
                :loading="submitLoading"
                :disabled="submitDisabled || areButtonsDisabled"
                color="primary"
                class="white--text"
                @click="submitCampaign"
            >
                Submit Campaign
                <v-icon right dark> mdi-cloud-upload </v-icon>
            </v-btn>
            <v-btn
                color="error"
                :disabled="areButtonsDisabled"
                @click="cancel()"
            >
                Cancel
            </v-btn>
            <v-btn
                v-if="!hasSubmitBtn"
                :loading="continueLoading"
                :disabled="continueDisabled || areButtonsDisabled"
                color="primary"
                @click="emitNextStep()"
            >
                Continue
            </v-btn>
            <v-btn
                v-if="hasPreviousStepBtn"
                text
                :disabled="areButtonsDisabled"
                @click="emitPreviousStep()"
            >
                Previous Step
            </v-btn>
        </div>
        <div class="form-field">
            <v-btn
                color="warning"
                :disabled="areButtonsDisabled"
                @click="reset()"
            >
                Reset the wizard
            </v-btn>
        </div>
    </div>
</template>
<script>
    export default {
        emits: [
            'reset',
            'cancel',
            'next-step',
            'previous-step',
            'submit-campaign'
        ],
        props: {
            hasPreviousStepBtn: {
                type: Boolean,
                required: false,
                default: false
            },
            hasSubmitBtn: {
                type: Boolean,
                required: false,
                default: false
            },
            submitLoading: {
                type: Boolean,
                required: false,
                default: false
            },
            submitDisabled: {
                type: Boolean,
                required: false,
                default: false
            },
            continueLoading: {
                type: Boolean,
                required: false,
                default: false
            },
            continueDisabled: {
                type: Boolean,
                required: false,
                default: false
            },
            needsPadding: {
                type: Boolean,
                required: false,
                default: false
            },
            areButtonsDisabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            reset() {
                this.$emit('reset')
            },
            cancel() {
                this.$emit('cancel')
            },
            emitNextStep() {
                this.$emit('next-step')
            },
            emitPreviousStep() {
                this.$emit('previous-step')
            },
            submitCampaign() {
                this.$emit('submit-campaign')
            }
        }
    }
</script>

<style scoped lang="scss">
.actions {
    width: 100%;
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;

    &.padded {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .form-field {
        display: flex;
        gap: 1rem;
    }
}

@media (max-width: 992px) {
    .actions {
        flex-direction: column;

        .form-field {
            flex-direction: column;
            align-items: center;

            button {
                width: 50vw;
            }
        }
    }
}
</style>
